import { createContext } from "react";

export interface ThreeDotsOverlayContextProps {
  isVisible: boolean;
  showOverlay: () => void;
  hideOverlay: () => void;
}

export const ThreeDotsOverlayContext = createContext<
  ThreeDotsOverlayContextProps | undefined
>(undefined);
